import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import HeatmapNavigator from '@Pages/Heatmap/HeatmapNavigatorDialog/components/HeatmapNavigator';
import RouteChangeTracking from '@Services/RouteChangeTracking';

import './HeatmapNavigatorDialog.scss';

function HeatmapNavigatorDialog({ closed, selfClose, animated, matrixName }) {
  useEffect(() => {
    RouteChangeTracking.handleSkipLinkFocus();
  }, []);
  return (
    <GeneralDialogLayout
      id="heatmap-navigator-dialog"
      className="heatmap-navigator-dialog"
      headerClassName="heatmap-navigator-dialog__header"
      contentClassName="heatmap-navigator-dialog__content"
      closed={closed}
      selfClose={selfClose}
      animated={animated}
      size="fit"
      needKeepFocus={false}
      movable
      movableSaveCoordinates
      header={<h3>Navigator</h3>}>
      <HeatmapNavigator onClose={selfClose} matrixName={matrixName} />
    </GeneralDialogLayout>
  );
}

HeatmapNavigatorDialog.propTypes = {
  closed: PropTypes.bool,
  selfClose: PropTypes.func,
  animated: PropTypes.bool,
  matrixName: PropTypes.string,
};

export default HeatmapNavigatorDialog;
